import { getBaseRole } from '@/helpers/customRoles'

export type VkIntegrationLeadChatAvailability = {
  isConfigured: boolean
  isActive: boolean
  canUseLeadChat: boolean
}

export const VK_INTEGRATION_LEAD_CHAT_UNAVAILABLE: VkIntegrationLeadChatAvailability =
  {
    isConfigured: false,
    isActive: false,
    canUseLeadChat: false,
  }

/** Бейджи непрочитанных ВК — только при включённой интеграции (`is_active`). */
export const isVkIntegrationUnreadBadgesEnabled = (integration: {
  isLoading?: boolean
  isActive: boolean
}): boolean => !integration.isLoading && integration.isActive

/** Поля ссылок ВК в карточке лида — подключена и включена (`canUseLeadChat`). */
export const isVkIntegrationLeadProfileFieldsEnabled = (
  integration: VkIntegrationLeadChatAvailability & { isLoading?: boolean },
): boolean => !integration.isLoading && integration.canUseLeadChat

export const VK_LEAD_CHAT_ALLOWED_ROLES = [
  'admin',
  'junior-admin',
  'head-of-sales',
  'sales-manager',
] as const

/** Док-лаунчер ВК-чата / CRM-интеграций — админы, мл. админ, РОП, менеджеры. */
export const isVkLeadChatRoleAllowed = (role?: string | null): boolean =>
  typeof role === 'string' &&
  (VK_LEAD_CHAT_ALLOWED_ROLES as readonly string[]).includes(getBaseRole(role))

export const isCrmIntegrationLeadChatRoleAllowed = isVkLeadChatRoleAllowed
